import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  exports: [
    MatSelectModule,
    MatCheckboxModule,
    MatInputModule
  ]
})
export class SalesforceSharedModule {}
